import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { ArrowDownLeft } from 'lucide-react';
import CxPPanel from '../components/flujo-caja/CxPPanel';
import FirstTimeHint from '../components/FirstTimeHint';

/**
 * Cuentas por Pagar (Nóminas de Viernes) — página dedicada.
 *
 * Carlos (Feb 2026): Antes vivía como bloque colapsable dentro de FlujoCajaPage.
 * Lo extrajimos como submódulo independiente en el sidebar para acceso directo
 * sin abrir el flujo completo.
 */
export default function CxPNominasPage() {
  return (
    <div className="space-y-4 p-2 md:p-4" data-testid="cxp-nominas-page">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <ArrowDownLeft className="w-6 h-6 text-red-600" />
          Cuentas por Pagar (Nóminas de Viernes)
        </h1>
        <p className="text-sm text-muted-foreground">
          Facturas de proveedores agrupadas por viernes de pago. Edita fechas, mueve facturas y marca pagadas.
        </p>
      </div>

      <FirstTimeHint
        hintId="cxp-nominas-flujo"
        title="Tip: cómo usar las nóminas de viernes"
        description="Cada nómina agrupa las facturas que vencen el mismo viernes. Puedes editar la fecha de pago de cualquier factura para moverla a otra nómina, marcarlas como pagadas, o sincronizar con Alegra. También tienes Imprimir + Excel en cada nómina."
      />

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Nóminas activas</CardTitle>
          <CardDescription className="text-xs">
            Las facturas se agrupan automáticamente por la próxima fecha de pago efectiva (o fecha de vencimiento).
          </CardDescription>
        </CardHeader>
        <CardContent>
          <CxPPanel />
        </CardContent>
      </Card>
    </div>
  );
}
